import api from './api';
import type { User, UserRole, Role } from '../types';

interface CreateUserData {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone?: string;
  role: UserRole;
}

interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  status?: 'active' | 'inactive';
}

export const userService = {
  async getUsers(): Promise<User[]> {
    const response = await api.get<User[]>('/company/users');
    return response.data;
  },

  async getUserById(id: string): Promise<User> {
    const response = await api.get<User>(`/company/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserData): Promise<User> {
    const response = await api.post<User>('/company/users', data);
    return response.data;
  },

  async updateUser(id: string, data: UpdateUserData): Promise<User> {
    const response = await api.patch<User>(`/company/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id: string): Promise<void> {
    await api.delete(`/company/users/${id}`);
  },

  async resendInvite(id: string): Promise<void> {
    await api.post(`/company/users/${id}/resend-invite`);
  },

  async getRoles(): Promise<Role[]> {
    const response = await api.get<Role[]>('/company/roles');
    return response.data;
  },

  async updateUserRole(userId: string, roleId: string): Promise<User> {
    const response = await api.patch<User>(`/company/users/${userId}/role`, { roleId });
    return response.data;
  },
};
